//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {appBaseUrl} from "../../utils/commons";
export default {
  name: "supplier",
  data() {
    return {
      value: '',
      wrapperHeight: 0,
      allLoaded: false,
      page: 0,
      show:true,
      supplierList: [],
      searchData: {},
      statusList: ['全部','注册','潜在','合作中','停用','黑名单'],
      levelList: [],
      businessList: [],
      codeSort: 'DESC',
      rulesObj:{
        search:'',
        status:'',
        levelType:'',
        business:'',
        itemStatus:'',
        supType:''
      },
      pageRules:{
        direction: "DESC",
        fromClientType: "h5",
        number: 0,
        property: "id",
        size:10,
        rules:[],
        specialConditions: [],
        workflowSearchBean:{
        }
      }
    }
  },
  methods: {
    clear() {
      delete this.rulesObj.search;
      this.getSupplierList();
    },
    searchList(e) {
      if(e){
        this.rulesObj.search={field: "supBasicInfo.shortName-supplierName-supplierCode",option:"LIKE_ANYWHERE",values:[e.key]}
      }else{
        delete this.rulesObj.search
      }
      this.getSupplierList();
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      if (this.$store.state.device === 'wap') {
        this.wrapperHeight =
          document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 60;
      } else {
        this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
      }
    },
    onItemClick(e) {
      if(e === '全部'){
        delete this.rulesObj.itemStatus;
      }else{
        this.rulesObj.itemStatus={field: "supManageInfo.status.supcrossstaName",option: "IN",values:[e]}
      }
      this.getSupplierList();
    },
    changeSort() {
      if (this.codeSort === 'DESC') {
        this.codeSort = 'ASC';
      } else {
        this.codeSort = 'DESC';
      }
      this.getSupplierList();
    },
    loadTop() {
      this.pageRules.number = 0 ;
      this.pageRules.rules=Object.values(this.rulesObj).filter(val=>val.field)
      this.$post('/api/supplier/page',this.pageRules).then((list) => {
        this.supplierList = list.content;
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.pageRules.number++;
      this.pageRules.rules=Object.values(this.rulesObj).filter(val=>val.field)
      this.$post('/api/supplier/page',this.pageRules).then((list) => {
        this.supplierList = this.supplierList.concat(list.content);
        this.$loadingHide();
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    getSupplierList() {
      this.$loadingShow();
      this.pageRules.rules=Object.values(this.rulesObj).filter(val=>val.field)
      this.$post('/api/supplier/page',this.pageRules).then((list) => {
        this.show=false;
        this.$nextTick(()=>{
          this.supplierList = list.content;
          this.show=true;
        });
        this.$loadingHide();
        this.pageRules.rules=[];
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //跳转到详情页
    goSupplierDetail(supplier) {
      if (this.$store.state.device === 'wap') {
        this.$router.push('/sup-view/' + supplier.id);
      }
    },
    // 跳转到个人设置页
    goUserSetting() {
      if (this.$store.state.device === 'wap') {
        this.$router.push('/home/mine');
      } else {
        document.location = "http://action:10061/?url=" + appBaseUrl + "home/mine?device=" + this.$store.state.device + '&&hiddentitle=1';
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.init();
    });
    this.getSupplierList();
  }
}



// WEBPACK FOOTER //
// ./src/page/home/supplier.vue